var exports = {
  "IW": "VoiceParticipantAvatarList.module__stackAvatar___NEhhTl",
  "K_": "VoiceParticipantAvatarList.module__stackAvatarSpeaking___NEhhTl",
  "Eh": "VoiceParticipantAvatarList.module__wrapContainer___NEhhTl",
  "EN": "VoiceParticipantAvatarList.module__wrapAvatarSlot___NEhhTl",
  "FU": "VoiceParticipantAvatarList.module__wrapAvatarSlotAnimated___NEhhTl",
  "ee": "VoiceParticipantAvatarList.module__wrapAvatar___NEhhTl",
  "lE": "VoiceParticipantAvatarList.module__wrapAvatarAnimated___NEhhTl",
  "i1": "VoiceParticipantAvatarList.module__remainingCount___NEhhTl",
  "jC": "VoiceParticipantAvatarList.module__popoutContainer___NEhhTl",
  "qE": "VoiceParticipantAvatarList.module__popoutList___NEhhTl",
  "Az": "VoiceParticipantAvatarList.module__popoutRow___NEhhTl",
  "ps": "VoiceParticipantAvatarList.module__popoutRowAvatar___NEhhTl",
  "fU": "VoiceParticipantAvatarList.module__popoutRowName___NEhhTl",
};

module.exports = exports;
